export type AddressFieldPath = string;

export function buildFieldPath(prefix: string | undefined, fieldName: string): AddressFieldPath {
  if (!prefix || !prefix.trim()) return fieldName;
  return `${prefix}.${fieldName}`;
}

function getPathParts(path: AddressFieldPath): string[] {
  return path.split(".").filter((part) => part.length > 0);
}

export function getPathValue<TValue = any>(source: any, path: AddressFieldPath): TValue | undefined {
  if (!source) return undefined;
  const parts = getPathParts(path);
  let current: any = source;
  for (const part of parts) {
    if (current == null) return undefined;
    current = current[part];
  }
  return current as TValue;
}

export function getPrefixedValue<TValue = any>(source: any, prefix: string | undefined, fieldName: string): TValue | undefined {
  return getPathValue<TValue>(source, buildFieldPath(prefix, fieldName));
}

export function getPrefixedError(source: any, prefix: string | undefined, fieldName: string): any {
  return getPathValue(source, buildFieldPath(prefix, fieldName));
}

export function getPrefixedTouched(source: any, prefix: string | undefined, fieldName: string): any {
  return getPathValue(source, buildFieldPath(prefix, fieldName));
}
